import { render, staticRenderFns } from "./OrderOtherDetail.vue?vue&type=template&id=e7f8b7dc&scoped=true&"
import script from "./OrderOtherDetail.vue?vue&type=script&lang=js&"
export * from "./OrderOtherDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7f8b7dc",
  null
  
)

export default component.exports